export enum TraderWorkStatus {
  Active = 'active',
  Inactive = 'inactive',
}
